module.exports = __webpack_public_path__ + "static/media/it.487ce9b6.svg";